/** Sidebar (and similar) can listen to refetch whether the user has persisted chat messages. */
export const USER_CHAT_ACTIVITY_REFRESH_EVENT = 'atrium:user-chat-activity-refresh'

export function requestUserChatActivityRefresh() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(USER_CHAT_ACTIVITY_REFRESH_EVENT))
}
